var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { padding: 0 }, attrs: { "max-width": "1000" } },
    [
      _c("w-card-title", [
        _vm._v(
          _vm._s(_vm.$ct("open-documentens-for", { name: _vm.contactName }))
        ),
      ]),
      _c(
        "app-reminder-send-modal-card",
        {
          style: { maxHeight: "100%", padding: 0 },
          attrs: { contact: _vm.contact },
        },
        [
          _c("app-custom-table", [
            _c("thead", [
              _c("tr", [
                _c(
                  "th",
                  { staticStyle: { width: "25px" } },
                  [
                    _c("w-switch", {
                      staticClass: "mls",
                      attrs: { value: _vm.allRemindersSelected },
                      on: {
                        input: function ($event) {
                          return _vm.setAllRemindersSelected($event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c("th", { staticStyle: { width: "85px" } }, [
                  _vm._v(" " + _vm._s(_vm.$ct("date")) + " "),
                ]),
                _c("th", { staticStyle: { width: "85px" } }, [
                  _vm._v(" " + _vm._s(_vm.$ct("id")) + " "),
                ]),
                _c("th", { staticClass: "amount" }, [
                  _vm._v(" " + _vm._s(_vm.$ct("amount")) + " "),
                ]),
                _c("th", { staticClass: "amount" }, [
                  _vm._v(" " + _vm._s(_vm.$ct("open")) + " "),
                ]),
                _c("th", {}, [_vm._v(" " + _vm._s(_vm.$ct("cost")) + " ")]),
                _c("th", {}, [
                  _vm._v(" " + _vm._s(_vm.$ct("interests")) + " "),
                ]),
                _c("th", { staticStyle: { width: "85px" } }, [
                  _vm._v(" " + _vm._s(_vm.$ct("expirationDate")) + " "),
                ]),
                _c("th"),
                _c("th", { staticClass: "center" }, [
                  _vm._v(" " + _vm._s(_vm.$ct("reminder")) + " "),
                ]),
              ]),
            ]),
            _c(
              "tbody",
              [
                _vm._l(_vm.reminders, function (reminder, i) {
                  return [
                    reminder.Sale
                      ? _c("tr", { key: i }, [
                          _c(
                            "td",
                            [
                              _c("w-switch", {
                                staticClass: "mls",
                                attrs: {
                                  value: _vm.isReminderSelected(reminder),
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.toggleReminder(reminder)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.localDate(reminder.Sale.InvoiceDate))
                            ),
                          ]),
                          _c("td", [
                            _vm._v(_vm._s(reminder.Sale.ComputedFriendlyID)),
                          ]),
                          _c("td", { staticClass: "amount" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.humanFloat(reminder.Sale.TotalIncVAT)
                                ) +
                                " "
                            ),
                          ]),
                          _c("td", { staticClass: "amount" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.humanFloat(reminder.Sale.TotalOpen)
                                ) +
                                " "
                            ),
                          ]),
                          _c(
                            "td",
                            { staticClass: "amount" },
                            [
                              _c("w-input-number", {
                                model: {
                                  value: reminder.Cost,
                                  callback: function ($$v) {
                                    _vm.$set(reminder, "Cost", $$v)
                                  },
                                  expression: "reminder.Cost",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "td",
                            { staticClass: "amount" },
                            [
                              _c("w-input-number", {
                                model: {
                                  value: reminder.Interest,
                                  callback: function ($$v) {
                                    _vm.$set(reminder, "Interest", $$v)
                                  },
                                  expression: "reminder.Interest",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.localDate(reminder.Sale.ExpirationDate)
                              )
                            ),
                          ]),
                          _c("td", [
                            _c("span", { staticClass: "st unpayed" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.printDayDiff(reminder.Sale.ExpirationDate)
                                )
                              ),
                            ]),
                          ]),
                          _c("td", { staticClass: "center" }, [
                            _c(
                              "span",
                              {
                                staticClass: "reminder-count",
                                class:
                                  "r" +
                                  (reminder.Sale.Reminder === 4
                                    ? 4
                                    : reminder.Sale.Reminder + 1),
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      reminder.Sale.Reminder === 4
                                        ? 4
                                        : reminder.Sale.Reminder + 1
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                }),
                !_vm.reminders.length
                  ? _c("tr", [
                      _c("td", { attrs: { colspan: "9" } }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$ct("no-open-expired-sales-found")) +
                            " "
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ],
              2
            ),
            _c("tfoot", [
              _c("tr", [
                _c("td"),
                _c("td"),
                _c("td"),
                _c("td", { staticClass: "amount" }),
                _c("td", { staticClass: "amount" }, [
                  _vm._v(" " + _vm._s(_vm.humanFloat(_vm.totalOpen)) + " "),
                ]),
                _c("td", { style: { paddingLeft: "20px" } }, [
                  _vm._v(" " + _vm._s(_vm.humanFloat(_vm.totalCost)) + " "),
                ]),
                _c(
                  "td",
                  {
                    staticClass: "right-align",
                    class: { "max-count-reached": _vm.maxCountReached },
                    attrs: { colspan: "4" },
                  },
                  [_vm._v(" " + _vm._s(_vm.selectCountText) + " ")]
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.nextDisabled, icon: "arrow-right" },
              on: {
                click: function ($event) {
                  return _vm.next()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.next")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }